import React from 'react';

// Fallback promos used when none are set on the Cuts page's promo fields.
// Copy + links match the B01-1001 redesign mockups.
const defaultPromos = [
  {
    title: 'Understanding Beef Quality Grades',
    text: 'Meat grading is administered by the United States Department of Agriculture – Agricultural Marketing Service (USDA-AMS).',
    link: '/cuts/beef-quality-grades',
    link_label: 'Learn More',
    image: ''
  },
  {
    title: 'Cooking Methods',
    text: 'So many ways to cook your beef, and all of them delicious. Try your hand at one of the Texas cooking styles—like smoking or gas grilling—or one of the other tried-and-true methods.',
    link: '/cooking-methods',
    link_label: 'Learn More',
    image: ''
  }
];

export default function CutsPromos({ promos }) {
  const items = promos && promos.length > 0 ? promos : defaultPromos;

  return (
    <section className="section cuts-promos">
      <div className="container">
        <div className="cuts-promos__grid">
          {items.map((promo, index) => (
            <article key={index} className="cuts-promo">
              <div className="cuts-promo__media">
                {promo.image ? (
                  <img src={promo.image} alt={promo.title} />
                ) : null}
              </div>
              <h3 className="cuts-promo__title">{promo.title}</h3>
              <p className="cuts-promo__text">{promo.text}</p>
              {promo.link ? (
                <a href={promo.link} className="btn btn--primary">
                  {promo.link_label || 'Learn More'}
                </a>
              ) : null}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
